import React from 'react';
import fr from 'facet-rest';
import { FDBox } from '@facet-wealth/design';
import { useListContextDispatch } from 'Components/UI/ListDetailView/ListContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import HeaderNew from '../HeaderNew';

const HeaderNewWithPadding = (props) => <FDBox paddingX={2}><HeaderNew {...props} /></FDBox>;

export default function FilesPicker(props) {
  const listDispatch = useListContextDispatch();
  const { householdResource } = useSimpleHousehold();

  const handleSuccessfulUpload = (rawResponse) => {
    const [createdResource] = fr.collection(rawResponse.data);

    listDispatch({ type: 'setFirstResource', resource: createdResource });
  };

  return (
    <HeaderNewWithPadding
      {...props}
      handleSuccessfulUpload={handleSuccessfulUpload}
      folderId={householdResource.attr('folderId')}
      householdId={householdResource.id()}
    />
  );
}
